<template>
<!-- :expanded.sync="expanded"
    :single-expand="singleExpand" :show-expand="false" -->
<v-data-table no-data-text="اطلاعاتی موجود نیست" :item-class="itemRowColor" :headers="headers" :items="data" disable-pagination :hide-default-footer="true" fixed-header item-key="key">
  <!-- <template v-slot:[`item.description`]="{ value }"> -->
  <!-- <v-btn to="/receipts/page/1" text>{{value.id}}</v-btn> -->

  <!-- {{value.text}}<a :href="receipts/page/1">{{ value.id }}</a> -->
  <!-- </template> -->
  <!-- <template v-slot:[`item.balance`]="{ item }">
    <span>{{ item.balance.toLocaleString() }}</span>
  </template>
  <template v-slot:[`item.lending`]="{ item }">
    <v-simple-checkbox v-model="item.lending" disabled></v-simple-checkbox>
  </template>
  <template v-slot:[`item.actions`]="{ item }">
    <v-icon color="orange darken-2" class="mr-2" @click="edit(item)">
      mdi-pencil
    </v-icon>
    <v-icon color="red darken-2" class="mr-2" @click='remove(item)'>
      mdi-delete
    </v-icon>
  </template> -->
  <!-- <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="3">
        _id ==> {{ item._id }}
      </td>
      <td :colspan="3">
        _id ==> {{ item._id }}
      </td>
    </template> -->
</v-data-table>
</template>

<script>
// import TutorialDataService from "../services/TutorialDataService";

export default {
  name: "table-list",
  data() {
    return {};
  },
  methods: {
    itemRowColor: function(item) {
      // console.log(item);
      if (item.total)
        return this.rmCamma(item.total) > 0 ? 'style-1' : 'style-2'
      if (item.lending_value)
        return this.rmCamma(item.lending_value) < 0 ? 'style-1' : 'style-2'
      if (item.debtor || item.creditor)
        return this.rmCamma(item.debtor) < 0 ? 'style-1' : 'style-2'
    },
  },
  props: ['loading', 'headers', 'data']
};
</script>

<style lang="scss">
.style-1 {
    color: black;
    // color: rgb(215,215,44);
}
.style-2 {
    color: blue;
}

table {
  direction: rtl;
  font-family: yekan;
  font-size: 12px !important;
  text-align: right;
}

table tr:nth-child(odd) {
  background-color: #fff;
}
table tr:nth-child(even) {
  background-color: #eee;
}

// table,
// td {
    // border: 2px solid lightgray;
    // border-collapse: separate;
    // font-size: 20px !important;
    // color: blue;
// }

th {
    border: 3px solid lightgray;
    border-collapse: inherit;
    font-size: 20px !important;
    background-color: #546E7A !important;
    color: whitesmoke !important;
    text-align: center;
}
</style>
